import React, { useState } from "react";
import "../styles/Navbar.css";
import { NavLink } from "react-router-dom";
import { useHomam } from "../context/HomamContext";
import { FaBars, FaTimes } from "react-icons/fa";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { isHomamActive } = useHomam();

  const closeMenu = () => setOpen(false);

  return (
    <>
      <nav className="navbar">
        <div className="container navbar-container">

          {/* DESKTOP MENU */}
          <div className="nav-items desktop-menu">
            <NavLink to="/" className={({ isActive }) => isActive ? "nav-btn active" : "nav-btn"}>Home</NavLink>
            <NavLink to="/about" className={({ isActive }) => isActive ? "nav-btn active" : "nav-btn"}>About</NavLink>
            <NavLink to="/poojas" className={({ isActive }) => isActive ? "nav-btn active" : "nav-btn"}>Poojas</NavLink>
            {isHomamActive && (
              <NavLink to="/nakshatra-homam" className={({ isActive }) => isActive ? "nav-btn active" : "nav-btn"}>
                Nakshatra Homam
              </NavLink>
            )}
            <NavLink to="/timings" className={({ isActive }) => isActive ? "nav-btn active" : "nav-btn"}>Timings</NavLink>
            <NavLink to="/festivals" className={({ isActive }) => isActive ? "nav-btn active" : "nav-btn"}>Festivals</NavLink>
            <NavLink to="/idols" className={({ isActive }) => isActive ? "nav-btn active" : "nav-btn"}>Idols</NavLink>
            <NavLink to="/gallery" className={({ isActive }) => isActive ? "nav-btn active" : "nav-btn"}>Gallery</NavLink>
            <NavLink to="/live-darshan" className={({ isActive }) => isActive ? "nav-btn active" : "nav-btn"}>Live Darshan</NavLink>
            <NavLink to="/spiritual-links" className={({ isActive }) => isActive ? "nav-btn active" : "nav-btn"}>Spiritual Links</NavLink>
            <NavLink to="/contact" className={({ isActive }) => isActive ? "nav-btn active" : "nav-btn"}>Contact</NavLink>
          </div>

          {/* MOBILE NAV BAR WRAPPER */}
          <div className="mobile-nav-bar">
            <button 
              className="menu-btn" 
              onClick={() => setOpen(true)}
              aria-label="Open Navigation Menu"
            >
              <FaBars className="menu-btn-icon" />
              <span>Menu</span>
            </button>
          </div>

        </div>
      </nav>

      {/* OVERLAY */}
      {open && <div className="overlay" onClick={closeMenu}></div>}

      {/* SIDEBAR */}
      <div className={`sidebar ${open ? "show" : ""}`}>
        <div className="sidebar-header">
          <h3>Menu</h3>
          <button className="sidebar-close-btn" onClick={closeMenu} aria-label="Close Menu">
            <FaTimes />
            <span>Close</span>
          </button>
        </div>

        <div className="sidebar-links">
          <NavLink onClick={closeMenu} to="/" className="side-link">Home</NavLink>
          <NavLink onClick={closeMenu} to="/about" className="side-link">About</NavLink>
          <NavLink onClick={closeMenu} to="/poojas" className="side-link">Poojas</NavLink>
          {isHomamActive && (
            <NavLink onClick={closeMenu} to="/nakshatra-homam" className="side-link">
              Nakshatra Homam
            </NavLink>
          )}
          <NavLink onClick={closeMenu} to="/timings" className="side-link">Timings</NavLink>
          <NavLink onClick={closeMenu} to="/festivals" className="side-link">Festivals</NavLink>
          <NavLink onClick={closeMenu} to="/idols" className="side-link">Idols</NavLink>
          <NavLink onClick={closeMenu} to="/gallery" className="side-link">Gallery</NavLink>
          <NavLink onClick={closeMenu} to="/live-darshan" className="side-link">Live Darshan</NavLink>
          <NavLink onClick={closeMenu} to="/spiritual-links" className="side-link">Spiritual Links</NavLink>
          <NavLink onClick={closeMenu} to="/contact" className="side-link">Contact</NavLink>
        </div>
      </div>
    </>
  );
};

export default Navbar;